<template>
  <div class="main index_wrap">
    <div class="clearfix wrap_box">
      <!----- start  ----->
      <div class="wrap_block" @click="handleNavigation('hualiangpei')">
        <div class="wrap_wrapper">
          <div class="wrap_con">
            <div class="wrap_modal"></div>
            <div class="wrap_bg">
              <img
                src="./../../../assets/imgs/maskl.jpg"
                width="1920"
                height="500"
                alt=""
              />
            </div>
            <div class="wrap_thumb">
              <div class="wrap_info">
                <a href="javascript:void(0)">
                  <div class="wrap_show">
                    <div class="wrap_logo">
                      <!-- <img
                        src="./../../../assets/imgs/am2.png"
                        height="auto"
                        alt=""
                      />
                      <img
                        src="./../../../assets/imgs/am.png"
                        height="auto"
                        alt=""
                      /> -->
                      <!-- 不确定图片 -->
                      <h1>{{ $t("system.home.hlp_title") }}</h1>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div class="wrap_detail">
              <div class="wrap_info">
                <a href="javascript:void(0)">
                  <div class="wrap_img"></div>
                  <div class="wrap_show">
                    <div class="wrap_logo">
                      <!-- <img
                        src="./../../../assets/imgs/am2.png"
                        height="auto"
                        alt=""
                      />
                      <img
                        src="./../../../assets/imgs/am.png"
                        height="auto"
                        alt=""
                      /> -->
                    </div>
                    <div class="wrap_text">
                      <div class="f40 wrap_des">
                        {{ $t("system.home.des_t") }}
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!---- middle ----->
      <div class="wrap_block" @click="handleNavigation('pinpaipeitao')">
        <div class="wrap_wrapper">
          <div class="wrap_con">
            <div class="wrap_modal"></div>
            <div class="wrap_bg">
              <img
                src="./../../../assets/imgs/maskr.jpg"
                width="1920"
                height="500"
                alt=""
              />
            </div>
            <div class="wrap_thumb">
              <div class="wrap_info">
                <a href="javascript:void(0)">
                  <div class="wrap_show">
                    <div class="wrap_logo">
                      <!-- <img
                        src="./../../../assets/imgs/zyi2.png"
                        height="88"
                        alt=""
                      />
                      <img
                        src="./../../../assets/imgs/zyi.png"
                        height="88"
                        alt=""
                      /> -->
                      <h1>{{ $t("system.home.brand_title") }}</h1>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div class="wrap_detail">
              <div class="wrap_info">
                <a href="javascript:void(0)">
                  <div class="wrap_img"></div>
                  <div class="wrap_show">
                    <div class="wrap_logo">
                      <!-- <img
                        src="./../../../assets/imgs/zyi2.png"
                        height="88"
                        alt=""
                      />
                      <img
                        src="./../../../assets/imgs/zyi.png"
                        height="88"
                        alt=""
                      /> -->
                    </div>
                    <div class="wrap_text">
                      <div class="f40 wrap_des">
                        {{ $t("system.home.des_b") }}
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- footer -->
    </div>
  </div>
</template>

<script setup lang="ts">
import axios from "./../../../utils/axios";
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useBreadcrumbStore } from "@/stores/breadcrumb";
const router = useRouter();
const { locale } = useI18n();
const breadcrumbStore = useBreadcrumbStore();
const menuData = ref([]);
onMounted(() => {
  fetchMenuData();
});
const getTranslatedText = (
  translations: any,
  key: string,
  defaultText: string = ""
) => {
  if (!translations) return defaultText;
  return (
    translations[locale.value]?.[key] ||
    translations["zh-cn"]?.[key] ||
    translations["en"]?.[key] ||
    defaultText
  );
};
const fetchMenuData = async () => {
  try {
    const response = await axios.get("/framework/product/list/tree");
    menuData.value = response;
  } catch (error) {
    console.error("获取菜单数据失败:", error);
  }
};
interface MenuItem {
  id: string;
  name: string;
  level: number;
  hasSystem: number;
  systemLayout: string;
  belongType: string;
  translations: any;
  children?: MenuItem[];
}

// 添加配置对象
const MENU_CONFIG = {
  hualiangpei: {
    belongType: "OEM",
    name: {
      'zh-cn': '华联配',
      'en': 'HULIANPEI'
    }
  },
  pinpaipeitao: {
    belongType: "BRAND",
    name: {
      'zh-cn': '配套定制',
      'en': 'Customized Matching'
    }
  },
};

const handleNavigation = async (type: string) => {
  console.log(type);

  try {
    const productData = menuData.value;
    const config = MENU_CONFIG[type as keyof typeof MENU_CONFIG];

    if (!config) {
      console.error("未知的导航类型");
      return;
    }

    const parent = productData.find(
      (item: MenuItem) => item.belongType === config.belongType
    );
    const targetItem = parent.children.find(item => {
      const currentName = item.translations?.[locale.value]?.cname;
      return currentName === config.name[locale.value];
    });


    if (!targetItem) {
      console.error("未找到目标菜单项");
      return;
    }

    // 设置面包屑
    breadcrumbStore.setBreadcrumbs([
      {
        title: getTranslatedText(targetItem.translations, "cname"),
        translations: targetItem.translations,
      },
    ]);

    // 处理跳转逻辑
    if (targetItem.level === 2) {
      await router.push({
        path: "/home/product-system",
        query: {
          ...(targetItem.hasSystem === 1
            ? { systemId: targetItem.id }
            : { menuId: targetItem.id }),
          systemLayout: targetItem.systemLayout,
          parentId: parent?.id || "",
        },
      });
      window.location.reload();
    } else if (targetItem.level === 3 && targetItem.hasSystem !== 1) {
      await router.push({
        path: "/home/productlist",
        query: { cid: targetItem.id },
      });
    }
  } catch (error) {
    console.error("导航失败:", error);
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.index_wrap {
  padding-top: 0;
  padding-bottom: 0;
}
.main {
  position: relative;
  background: 50% 0 no-repeat fixed;
  background-size: cover;
  overflow: hidden;
}
.wrap_box {
  display: flex;
  width: 128%;
  height: 500px;
  overflow: hidden;
}
.wrap_block {
  height: 100%;
  flex: 1 1 50%;
  transition: all 1s;
  will-change: auto;
}
.wrap_block {
  position: relative;
  height: 500px;
}
.wrap_wrapper {
  box-sizing: border-box;
  transform: skew(-30deg);
  transform-origin: left top;
  overflow: hidden;
}
.wrap_wrapper {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
}
.wrap_block:nth-child(1) .wrap_wrapper::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  width: 10px;
  height: 100%;
  background-color: #fff;
  opacity: 1;
}
.wrap_con {
  width: 1920px;
  transform: translate(-50%, 0) skew(30deg);
}
.wrap_con {
  position: absolute;
  top: 0;
  left: 50%;
  height: 100%;
  transform-origin: left top;
  background: #e3e3e3;
}
.wrap_modal {
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    107deg,
    rgba(255, 255, 255, 1) 40%,
    rgba(255, 255, 255, 0) 100%
  );
  opacity: 0.7;
  z-index: 1;
  transition: all 0.6s;
}
.wrap_bg {
  width: 100%;
  height: 100%;
  transition: transform 0.5s;
}

.wrap_bg img {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-position: 80%;
  object-fit: cover;
  transition: opacity 0.5s;
}
img {
  border: none;
  display: inline-block;
  max-width: 100%;
  height: auto;
}
.wrap_thumb {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.5s;
}
.wrap_info {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  width: 100%;
}
.wrap_info a {
  display: flex;
  justify-content: center;
  align-items: center;
}

.wrap_thumb a {
  color: #85332d;
}
.wrap_show {
  display: flex;
  align-items: center;
}
.wrap_logo {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  height: 88px;
  margin-right: 20px;
}
.wrap_logo img {
  max-height: 100%;
  width: auto;
}
.wrap_logo img:nth-child(2) {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
}
.wrap_text {
  flex: 1 0 0;
  width: auto;
}
.f30 {
  font-size: 30px;
}
.wrap_tit {
  font-weight: bold;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  padding: 0;
  margin: 0;
  line-height: 1.1;
}
.wrap_detail {
  opacity: 0;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(121, 195, 222, 0.1),
    rgba(121, 195, 222, 0.978)
  );
  transition: opacity 0.6s;
  padding-left: 300px;
  color: #ffffff;
}
.wrap_block:nth-child(2) .wrap_detail {
  background: linear-gradient(
    to right,
    rgba(121, 195, 222, 0.1),
    rgba(121, 195, 222, 0.978)
  );
}
.wrap_detail a {
  color: #ffffff;
}
.wrap_img {
  width: 360px;
  margin-right: 40px;
  display: none;
}
.wrap_img .ico_box {
  padding-top: 75%;
}

.ico_box {
  position: relative;
  display: block;
  height: 0;
  padding-top: 100%;
}
.ico_box img {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.wrap_show {
  display: flex;
  align-items: center;
}
.wrap_detail .wrap_logo img:nth-child(1) {
  opacity: 0;
}
.wrap_detail .wrap_logo img:nth-child(2) {
  opacity: 1;
}
.f20 {
  font-size: 20px;
}
.wrap_des {
  line-height: 1.5;
}
.f40 {
  font-size: 40px;
}
.wrap_wrapper::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(107deg, #85332d 20%, rgba(133, 51, 45, 0) 100%);
  opacity: 0;
  visibility: hidden;
  transition: all 0.6s;
}
.wrap_block:nth-child(2) .wrap_con {
  margin-left: -350px;
}
.clearfix:after {
  content: "\200B";
  display: block;
  clear: both;
  height: 0;
}
.wrap_box .wrap_block:hover {
  flex: 1 0 78%;
}
.wrap_box .wrap_block:hover .wrap_modal {
  opacity: 0;
  visibility: hidden;
}
.wrap_box .wrap_block:hover .wrap_thumb {
  opacity: 0;
  z-index: 1;
}
.wrap_box .wrap_block:hover .wrap_detail {
  opacity: 1;
  z-index: 2;
}
</style>
